module.exports = __webpack_public_path__ + "static/img/loginbg.f1b1a6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loginbg.png
// module id = 718
// module chunks = 25